export default __webpack_public_path__ + "media/images/clients-02-151x106-327ac0ba843d8bb1998277ffd8d8d5a7.png";